<template>
  <div>
    <div class="head" :class="{ 'teamwork-page': isTeamworkPage }">
      <div class="logo" @click="$router.push('/')">
        <img
          width="300px"
          height="60px"
          src="../src/assets/logowhite.png"
          alt=""
        />
      </div>
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-btn" @click="openSidebar">
        <span></span><span></span><span></span>
      </div>
      <div class="nav-content" style="font-size: 14px; font-weight: 500">
        <nav class="nav-links" @mouseenter="navHover = true" @mouseleave="navHover = false">
          <div class="nav-bar-row">
            <div
              v-if="isHotelOrSleep"
              class="nav-back-btn no-bg"
              @click="$router.push('/')"
            >‹</div>
            <div class="nav-links-inner">
              <a
                v-if="isHotelOrSleep"
                key="share"
                :class="{ active: $route.path === '/hotel' }"
                @click.prevent="goToHotelSub('/hotel')"
              >{{ t('nav.share') }}</a>
              <a
                v-if="isHotelOrSleep"
                key="sleep"
                :class="{ active: $route.path === '/sleep' }"
                @click.prevent="$router.push('/sleep')"
              >{{ t('nav.sleep') }}</a>
              <router-link
                v-if="!isHotelOrSleep"
                key="home"
                to="/"
              >{{ t('nav.home') }}</router-link>
              <router-link
                v-if="!isHotelOrSleep"
                key="hotel"
                to="/hotel"
              >{{ t('nav.hotel') }}</router-link>
              <a
                v-if="!isHotelOrSleep"
                key="alibaba"
                href="https://metatree.en.alibaba.com/?spm=a2700.29482153.0.0.29ef71d2O4Zmt3"
                target="_blank"
                rel="noopener noreferrer"
                class="nav-link"
              >{{ t('nav.alibaba') }}</a>
              <router-link
                v-if="!isHotelOrSleep"
                key="teamwork"
                to="/teamwork"
              >{{ t('nav.teamwork') }}</router-link>
              <router-link
                v-if="!isHotelOrSleep"
                key="aboutus"
                to="/aboutus"
              >{{ t('nav.about') }}</router-link>
              <router-link
                v-if="!isHotelOrSleep"
                key="hire"
                to="/hire"
              >{{ t('nav.join') }}</router-link>
              <div class="lang-switch">
                <button :class="{ active: lang === 'zh' }" @click="switchLang('zh')">{{ t('nav.lang.zh') }}</button>
                <span class="sep">|</span>
                <button :class="{ active: lang === 'en' }" @click="switchLang('en')">{{ t('nav.lang.en') }}</button>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <!-- 移动端侧边栏 -->
    <div class="mobile-sidebar-mask" v-if="sidebarOpen" @click="closeSidebar"></div>
    <div class="mobile-sidebar" v-if="sidebarOpen">
      <div v-if="!sidebarHotelMode">
        <div class="sidebar-close" @click="closeSidebar">×</div>
        <div class="sidebar-links">
          <router-link to="/" @click.native="closeSidebar">{{ t('nav.home') }}</router-link>
          <a @click.prevent="openHotelMenu">{{ t('nav.hotel') }}</a>
          <a
            href="https://metatree.en.alibaba.com/?spm=a2700.29482153.0.0.29ef71d2O4Zmt3"
            target="_blank"
            rel="noopener noreferrer"
            @click.native="closeSidebar"
          >{{ t('nav.alibaba') }}</a>
          <router-link to="/teamwork" @click.native="closeSidebar">{{ t('nav.teamwork') }}</router-link>
          <router-link to="/aboutus" @click.native="closeSidebar">{{ t('nav.about') }}</router-link>
          <router-link to="/hire" @click.native="closeSidebar">{{ t('nav.join') }}</router-link>
          <div class="sidebar-lang">
            <button :class="{ active: lang === 'zh' }" @click="switchLangThenClose('zh')">{{ t('nav.lang.zh') }}</button>
            <span class="sep">|</span>
            <button :class="{ active: lang === 'en' }" @click="switchLangThenClose('en')">{{ t('nav.lang.en') }}</button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="sidebar-back" @click="sidebarHotelMode = false">‹</div>
        <div class="sidebar-links">
          <a @click.prevent="goToHotelSub('/hotel')">{{ t('nav.share') }}</a>
          <a @click.prevent="goToHotelSub('/sleep')">{{ t('nav.sleep') }}</a>
        </div>
      </div>
    </div>
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>
<script>
import { t, i18nStore, setLang } from './i18n'
import { setLang as setLangMobile } from './i18n-x'
export default {
  data() {
    return {
      navHover: false,
      sidebarOpen: false,
      sidebarHotelMode: false // 新增状态
    }
  },
  computed: {
    isHotelOrSleep() {
      return this.$route.path === '/hotel' || this.$route.path === '/sleep';
    },
    isTeamworkPage() {
      return this.$route.path === '/teamwork';
    },
    lang() {
      return i18nStore.lang
    }
  },
  methods: {
    t,
    openHotelMenu() {
      this.sidebarHotelMode = true;
    },
    closeSidebar() {
      this.sidebarOpen = false;
      this.sidebarHotelMode = false;
    },
    goToHotelSub(path) {
      if (path === '/hotel' && window.innerWidth <= 768) {
        if (this.$route.path !== '/testpage') {
        this.$router.push('/testpage');
        }
      } else {
        if (this.$route.path !== path) {
        this.$router.push(path);
        }
      }
      this.closeSidebar();
    },
    openSidebar() {
      // 新增：根据当前路由决定打开哪个菜单
      this.sidebarOpen = true;
      this.sidebarHotelMode = this.isHotelOrSleep;
    },
    switchLang(lang) {
      if (window.innerWidth <= 768) {
        setLangMobile(lang)
      } else {
        setLang(lang)
      }
    },
    switchLangThenClose(lang) {
      if (window.innerWidth <= 768) {
        setLangMobile(lang)
      } else {
        setLang(lang)
      }
      this.closeSidebar()
    }
  }
}
</script>
<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100vw;
  overflow-x: hidden;
  background: rgb(255, 248, 237);
}
#app {
  width: 100vw;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: rgb(255, 248, 237);
}
.logo {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo img {
  width: 300px !important;
  height: 60px !important;
  object-fit: contain;
  display: block;
  min-width: 300px;
  min-height: 60px;
  transition: all 0.3s ease;
}
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  z-index: 1000;
  /* 恢复为无flex布局 */
  /* 毛玻璃效果 */
  background: linear-gradient(to bottom, rgba(40, 40, 40, 0.7), rgba(40, 40, 40, 0.2));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

/* Teamwork页面导航栏样式 */
.head.teamwork-page {
  background: linear-gradient(to bottom, rgba(40, 40, 40, 0.7), rgba(40, 40, 40, 0.2));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(10px);
}

.head.teamwork-page:hover {
  background: linear-gradient(
    to bottom,
    rgba(40, 40, 40, 0.7) 30%,
    rgba(40, 40, 40, 0.5) 80%,
    rgba(40, 40, 40, 0.1) 100%
  );
}

/* 悬停时展开容器 */
.head:hover {
  height: 150px;
  background: linear-gradient(
    to bottom,
    rgba(40, 40, 40, 0.7) 30%,
    rgba(40, 40, 40, 0.5) 80%,
    rgba(40, 40, 40, 0.1) 100%
  );
}

.nav-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  transform: translateY(100%);
  transition: transform 0.3s ease 0.1s;
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.head:hover .nav-content {
  transform: translateY(0);
}

/* 导航样式 */
.nav-links {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-top: -20px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.2em;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background 0.3s ease;
}

/* Teamwork页面导航链接颜色 */
.head.teamwork-page .nav-links a {
  color: white;
}

.head.teamwork-page .nav-links a:hover {
  background: rgba(255, 255, 255, 0.5);
  color: #333;
}

.nav-links a:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* 阿里国际站链接样式 */
.nav-links .nav-link {
  color: white;
  text-decoration: none;
  font-family: Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-size: 1.2em;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background 0.3s ease;
  cursor: pointer;
}

.nav-links .nav-link:hover {
  background: rgba(255, 255, 255, 0.5);
  color: #333;
}

.logo img {
  width: 250px;
  height: 45px;
  display: block;
}

.main-content {
  /* 删除 main-content 的 padding-top */
}
.nav-links-inner {
  display: flex;
  gap: 30px;
  justify-content: center;
}
.nav-links-inner.center {
  width: 500px;
  margin: 0 auto;
  justify-content: center;
}
.nav-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #fff;
  background: rgba(0,0,0,0.2);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  margin-right: 16px;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;
}
.nav-back-btn:hover {
  background: rgba(0,0,0,0.4);
}
.nav-fade-enter-active, .nav-fade-leave-active {
  transition: opacity 0.3s;
}
.nav-fade-enter, .nav-fade-leave-to {
  opacity: 0;
}
.nav-links a.active {
  background: none;
}
.nav-links-inner a:hover {
  background: rgba(255,255,255,0.5);
  color: #333;
}
.nav-links-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.nav-links-flex.center {
  width: 500px;
  margin: 0 auto;
  justify-content: center;
}
.nav-bar-row {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}
.nav-back-btn.no-bg {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none !important;
  border-radius: 0;
  box-shadow: none;
  font-size: 2rem;
  color: #fff;
  width: 36px;
  height: 36px;
  margin-right: 16px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Teamwork页面返回按钮颜色 */
.head.teamwork-page .nav-back-btn.no-bg {
  color: #fff;
}
.nav-links-inner {
  margin: 0 auto;
  display: flex;
  gap: 30px;
  justify-content: center;
}
.nav-links-inner a,
.nav-links-inner router-link {
  cursor: pointer;
}
.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}
.lang-switch button {
  background: transparent;
  border: 1px solid rgba(255,255,255,0.6);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95em;
}
.lang-switch .sep { color: rgba(255,255,255,0.7); }
.lang-switch button.active { background: rgba(255,255,255,0.25); }
/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  width: 36px;
  height: 36px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 5px;
  z-index: 1200;
}
.mobile-menu-btn span {
  display: block;
  width: 28px;
  height: 4px;
  background: #fff;
  margin: 3px 0;
  border-radius: 2px;
  transition: all 0.3s;
}

/* Teamwork页面移动端菜单按钮颜色 */
.head.teamwork-page .mobile-menu-btn span {
  background: #fff;
}
/* 侧边栏遮罩 */
.mobile-sidebar-mask {
  display: none;
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1500;
}
/* 侧边栏 */
.mobile-sidebar {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 70vw;
  max-width: 320px;
  height: 100vh;
  background: #222;
  color: #fff;
  z-index: 1600;
  box-shadow: 2px 0 8px rgba(0,0,0,0.2);
  padding: 24px 16px 0 16px;
  transition: transform 0.3s;
}
.sidebar-close {
  font-size: 2rem;
  cursor: pointer;
  margin-bottom: 24px;
  text-align: right;
}
.sidebar-links {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.sidebar-links a, .sidebar-links router-link {
  color: #fff;
  font-size: 1.2em;
  text-decoration: none;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.sidebar-links a:last-child, .sidebar-links router-link:last-child {
  border-bottom: none;
}
.sidebar-lang {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 12px;
}
.sidebar-lang button {
  background: transparent;
  border: 1px solid rgba(255,255,255,0.6);
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.sidebar-lang .sep { color: rgba(255,255,255,0.7); }
.sidebar-lang button.active { background: rgba(255,255,255,0.25); }
.sidebar-back {
  font-size: 2rem;
  cursor: pointer;
  margin-bottom: 24px;
  text-align: left;
  color: #fff;
  user-select: none;
}

@media (max-width: 768px) {
  .head {
    height: 56px !important;
    min-height: 56px !important;
    max-height: 56px !important;
    overflow: visible;
  }
  .logo {
    height: 56px;
    display: flex;
    align-items: center;
  }
  .logo img {
    height: 20px;
    max-height: 20px;
    width: auto;
    object-fit: contain;
    display: block;
    transform: scale(0.8);
  }
  .head:hover {
    height: 56px !important;
    min-height: 56px !important;
    max-height: 56px !important;
  }
  .nav-content, .nav-links, .nav-links-inner {
    display: none !important;
  }
  .mobile-menu-btn {
    display: flex;
  }
  .mobile-sidebar-mask {
    display: block;
  }
  .mobile-sidebar {
    display: block;
    animation: sidebarIn 0.3s;
  }
}
@keyframes sidebarIn {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}
@media (max-width: 480px) {
  .head {
    height: 44px !important;
    min-height: 44px !important;
    max-height: 44px !important;
    overflow: visible;
  }
  .logo {
    height: 44px;
    display: flex;
    align-items: center;
  }
  .logo img {
    height: 16px;
    max-height: 16px;
    width: auto;
    object-fit: contain;
    display: block;
    transform: scale(0.7);
  }
  .head:hover {
    height: 44px !important;
    min-height: 44px !important;
    max-height: 44px !important;
  }
}
</style>
